import SearchOffIcon from "@mui/icons-material/SearchOff";
import { Box, Typography } from "@mui/material";

interface EmptyStateProps {
  message: string;
  suggestion?: string;
  /** Named separately where a screen shows more than one empty state. */
  "data-testid"?: string;
}

export function EmptyState({
  message,
  suggestion,
  "data-testid": dataTestId = "s12-empty-state",
}: EmptyStateProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 6,
        px: 3,
        textAlign: "center",
      }}
      data-testid={dataTestId}
    >
      <SearchOffIcon
        sx={{
          fontSize: 64,
          color: "text.disabled",
          mb: 2,
        }}
      />
      <Typography
        variant="h6"
        gutterBottom
        sx={{
          color: "text.secondary",
        }}
      >
        {message}
      </Typography>
      {suggestion && (
        <Typography
          variant="body2"
          sx={{
            color: "text.disabled",
          }}
        >
          {suggestion}
        </Typography>
      )}
    </Box>
  );
}
